import type { GlassData, GlassInventoryEntry } from "../types";

export interface ColourScheme {
  label: string;
  offsets: number[];
}

export const zeroPad = (code: string, length: number): string =>
  code.padStart(length, "0");

export const padPrefix = (prefix: string): string => zeroPad(prefix, 6);

export const findGlassInventoryEntry = (
  prefix: string,
  glassData: GlassData | null | undefined,
): GlassInventoryEntry | undefined => {
  const inventory = glassData?.inventory;
  if (!inventory) return undefined;
  const padded = padPrefix(prefix);
  // Exact match first
  if (inventory[padded]) return inventory[padded];
  // Find first key that starts with the padded prefix (keys may have suffixes like "-0001")
  const key = Object.keys(inventory).find((k) => k.startsWith(padded));
  return key ? inventory[key] : undefined;
};

export const getPositionIndices = (selected: number, scheme: ColourScheme | null): number[] => {
  const indices = [selected];
  if (scheme) {
    for (const offset of scheme.offsets) {
      indices.push((selected + offset) % 12);
    }
  }
  return indices;
};
